import { BoxProps } from "@mui/system"
import React from "react"
import { useTranslation } from "react-i18next"
import { Box, Typography } from "src/UILibrary"
import { CareerInputItem } from "./CareerInputItem"
import Button from "@mui/material/Button"
import { Career } from "src/openapi"

type Props = {
  sx: BoxProps
  required?: boolean
  career: Career[]
  handleCareer: any
  validationMessage: string
}

export const CareerInputItems = ({
  sx,
  required,
  career,
  handleCareer,
  validationMessage,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "signup" })

  const style = sx || {}

  const removeItem = (index: number) => {
    let tmpCareer = [...career]
    tmpCareer.splice(index, 1)
    handleCareer(tmpCareer)
  }

  const addItem = () => {
    handleCareer([...career, { year: 1970, month: 1, career: "" } as Career])
  }

  return (
    <Box sx={{ width: "100%", ...style }}>
      <Box display="flex" sx={{ mb: "8px" }}>
        <Typography.InputFieldTitle sx={{ mr: "6px", color: "text.primary" }}>
          {t("career")}
        </Typography.InputFieldTitle>
        {required && (
          <Box
            sx={{
              px: "8px",
              borderWidth: "1px",
              borderStyle: "solid",
              borderRadius: "4px",
              borderColor: "text.border",
            }}
          >
            <Typography.InputFieldRequired sx={{ m: "auto", color: "text.border" }}>
              {t("required")}
            </Typography.InputFieldRequired>
          </Box>
        )}
      </Box>
      <Box display="block" width="100%">
        {career.map((item, index) => {
          const handleYear = (year: number) => {
            let tempCareer = [...career]
            tempCareer[index].year = year
            handleCareer(tempCareer)
          }

          const handleMonth = (month: number) => {
            let tempCareer = [...career]
            tempCareer[index].month = month
            handleCareer(tempCareer)
          }

          const handleCareerMsg = (msg: string) => {
            let tempCareer = [...career]
            tempCareer[index].career = msg
            handleCareer(tempCareer)
          }

          if (index === 0) {
            return (
              <CareerInputItem
                key={index}
                year={item.year}
                month={item.month}
                career={item.career}
                handleYear={handleYear}
                handleMonth={handleMonth}
                handleCareer={handleCareerMsg}
                handleRemove={() => removeItem(index)}
              />
            )
          } else {
            return (
              <CareerInputItem
                key={index}
                sx={{ mt: "20px" }}
                year={item.year}
                month={item.month}
                career={item.career}
                handleYear={handleYear}
                handleMonth={handleMonth}
                handleCareer={handleCareerMsg}
                handleRemove={() => removeItem(index)}
              />
            )
          }
        })}
      </Box>
      <Button
        variant="outlined"
        sx={{
          width: "100%",
          mt: "20px",
          backgroundColor: "#F1F1F1",
          borderWidth: "1px",
          borderColor: "#F1F1F1",
        }}
        onClick={() => addItem()}
      >
        <Typography.ButtonText>+</Typography.ButtonText>
      </Button>
      <Box sx={{ height: "20px", pt: "5px" }}>
        {validationMessage && (
          <Typography.ValidationText>{validationMessage}</Typography.ValidationText>
        )}
      </Box>
    </Box>
  )
}
